<ng-container *ngIf="cs.vm$ | async as vm">
  <div [content]="main" editable-area></div>
</ng-container>
